import { reloadPage as reloadBrowserPage } from "./browser-navigation";

export function reloadPage() {
  reloadBrowserPage();
}
